import React, {useEffect, useState} from 'react';
import * as styles from './style.module.scss';
import {useTranslation} from 'gatsby-plugin-react-i18next';
const {
    postSidebar,
    postSidebarFixed,
    postSidebarBottom,
    postSidebar__links,
    postSidebar__link,
    postSidebar__linkActive,
    postSidebar__title
} = styles;

const PostSidebar = ({ headings }) => {
  const {t} = useTranslation();
  const [isFixed, setIsFixed] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const [scrollDisabled, setScrollDisabled] = useState(false);

  useEffect(() => {
    const postAuthor = document.querySelector('#post-author');
    const postSidebar = document.querySelector('#post-sidebar');
    const postContent = document.querySelector('#grid-content');
    const footer = document.querySelector('footer');
    const postContentOffset = postContent.offsetTop;
    const postSidebarOffset = 40;
    const trainingInfoBottom = window.innerHeight - (postSidebar.offsetHeight + postSidebarOffset);
    const authorPadding = 60;
    const handleScroll = () => {
      const elementTop = postAuthor ? postAuthor.offsetTop : footer.offsetTop;
      const viewportTop = window.scrollY || document.documentElement.scrollTop;
      const viewportBottom = viewportTop + window.innerHeight;
      if (postContentOffset < viewportTop + postSidebarOffset) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
      if (elementTop < viewportBottom - trainingInfoBottom + authorPadding) {
        postSidebar.classList.add(postSidebarBottom);
        const bottomFix = viewportBottom - elementTop + authorPadding;
        postSidebar.style.bottom = `${bottomFix}px`;
        return;
      }
      postSidebar.classList.remove(postSidebarBottom);
      postSidebar.style.bottom = 'auto';
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollDisabled) {
        const scrollPosition = window.scrollY;
  
        headings.forEach((section, index) => {
          const element = document.getElementById(index);
  
          if (element) {
            const sectionTop = element.offsetTop - 300;
            const sectionHeight = element.offsetHeight;
            
            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
              setActiveLink(index);
            }
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [headings, scrollDisabled]);

  const handleClick = (id) => {
    setScrollDisabled(true);
    setActiveLink(id);

    setTimeout(() => {
      setScrollDisabled(false);
    }, 500);
  }

  return (
    <section className={`${postSidebar} ${isFixed ? postSidebarFixed : ''}`} id='post-sidebar'>
      <p className={postSidebar__title}>{t("blog_post_table_of_contents")}</p>
      <div className={postSidebar__links}>
        {headings.map((heading, index) => (
          <a
            href={`#${index}`}
            className={`${postSidebar__link} ${activeLink === index ? postSidebar__linkActive : ''}`}
            key={index}
            onClick={() => handleClick(index)}
          >
            {heading.content[0].value}
          </a>
        ))}
      </div>
    </section>
  )
}

export default PostSidebar;

